import React from 'react';
import { Card } from '@mui/material';
import { Blue_Border } from '../constants';

const CardContainer = ({ children, sx = {} }) => {
    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: { lg: "row", xs: "column" },
                width: "100%",
                border: Blue_Border,
                boxShadow: "none",
                borderRadius: "15px",
                p: "16px 15px",
                ...sx, // Allow additional styles to be passed
            }}
        >
            {children}
        </Card>
    );
};

export default CardContainer;
